import { Box, Modal, Stack, Typography } from "@mui/material";
import { HCButton } from "@root/components/atoms/HCButton/Component";
import { DoorgaanIcon } from "@root/icons/Icons";
import { modalStyle } from "@root/misc/constants";
import { cardStyle } from "@root/utils/ui";
import type { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  hasError?: boolean;
  onErrorClose?: () => void;
  errorTitle?: ReactNode;
  errorDescription?: ReactNode;
  errorButtonLabel?: ReactNode;
}

export default function DtgPractiseField({
  children,
  hasError = false,
  onErrorClose,
  errorTitle = "Dat ging niet goed",
  errorDescription = "Er is niet op de juiste knop gedrukt of er is geen knop ingedrukt. Probeer het opnieuw.",
  errorButtonLabel = "Doorgaan",
}: Props): JSX.Element {
  return (
    <>
      <Modal
        disableAutoFocus
        keepMounted
        open={hasError}
        onClose={onErrorClose}
        aria-labelledby="playing-field-modal-title"
        aria-describedby="playing-field-modal-description"
      >
        <Box sx={modalStyle}>
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{ height: "100%", ...cardStyle }}
          >
            <div>
              <Typography id="playing-field-modal-title" variant="h6" component="h2">
                {errorTitle}
              </Typography>
              <Typography id="playing-field-modal-description" sx={{ mt: 2 }}>
                {errorDescription}
              </Typography>
            </div>
            <HCButton
              endIcon={<DoorgaanIcon />}
              state={{ kind: "primary", maxWidth: "fit-content" }}
              onClick={onErrorClose}
            >
              {errorButtonLabel}
            </HCButton>
          </Stack>
        </Box>
      </Modal>

      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        sx={{ height: "100%", width: "100%", ...cardStyle }}
      >
        <div style={{ width: "100%", color: "var(--color-brand-quaternary-500)" }}>{children}</div>
      </Stack>
    </>
  );
}
